const getLocalShowPrintKOTButton = () => {
  const val = localStorage.getItem("showPrintKOTButton");
  return val === null ? true : val === "true";
};
export default getLocalShowPrintKOTButton;
